import api from "@/vue-dlb/utils/pa-backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util';
import idb from '@/vue-dlb/utils/idb';

import {  
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const state = {
  masterItems: [],    
  comptext: "",
  biztext: "",
  srctext: "",
  rsttext: "",
  smptext: "",
  dataSet01Source: [],
  filter: {},
  fileViewWindowParam: {}
};

const getters = {
};

const actions = {
  getList: async ({ commit }, searchItems) => {    
    //console.log('-------------------2) cookies server=>' + $cookies.get('paproc-server'));      
    const retSet = new ObjDataSet("masterItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getSummaryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    //trSet.tranID = "EDP_ANALYSIS_LIST_PRCS_MST_SRM_FN";
    trSet.tranID = "PA_LIST_SMP_CLONE_PROC_IO_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {            
      commitRetDataSets(commit, res.data);
    });
  },  
  
  readEDIFile: async ({ commit }, edipath) => {
    console.log('comppath:' + edipath);    
    //let reqdata =  {FILE_PATH: edipath};  // changed to use FileID
    let reqdata =  {FILE_ID: edipath};
    api.readFile("EDIFileView", reqdata).then(res => {      
      commit('setEDIText', res.data);
    });
  },
  readSRCFile: async ({ commit }, srcpath) => {
    console.log('srcpath:' + srcpath);    
    //let reqdata =  {FILE_PATH: edipath};  // changed to use FileID
    let reqdata =  {FILE_ID: srcpath};
    api.readFile("EDIFileView", reqdata).then(res => {      
      commit('setSRCText', res.data);
    });
  },
  readRSTFile: async ({ commit }, rstpath) => {
    console.log('comppath:' + rstpath);    
    //let reqdata =  {FILE_PATH: edipath};  // changed to use FileID
    let reqdata =  {FILE_ID: rstpath};
    api.readFile("EDIFileView", reqdata).then(res => {      
      commit('setRSTText', res.data);
    });
  },
  readSMPFile: async ({ commit }, smppath) => {
    console.log('comppath:' + smppath);    
    //let reqdata =  {FILE_PATH: edipath};  // changed to use FileID
    let reqdata =  {FILE_ID: smppath};
    api.readFile("EDIFileView", reqdata).then(res => {      
      commit('setSMPText', res.data);
    });
  },
};

const mutations = {
  masterItems (state, datarows) {
    state.masterItems = datarows;
    state.dataSet01Source = datarows;
  },
  dataItems (state, datarows) {
    state.dataItems = datarows;
  },
  setEDIText (state, data) {    
    state.comptext = data;
  },
  setBizText (state, data) {    
    state.biztext = data;
  },  
  setSRCText (state, data) {    
    state.srctext = data;
  },  
  setRSTText (state, data) {    
    state.rsttext = data;
  },  
  setSMPText (state, data) {    
    state.smptext = data;
  },  
  'SET_STORE_MONITOR_LIST' (state, monitoringList) {
    state.monitoringList = monitoringList;
    state.monitoringListForFilter = monitoringList;
  },
  'SET_STORE_TOTAL_CNT' (state, trsDataCnt) {
    state.totalCnt = trsDataCnt;
  },
  'SET_FILEVIEW_WINDOW_PARAM' (state, fileView) {
    let fileViewWindowParam = state.fileViewWindowParam;
    fileViewWindowParam[fileView['ROWID']] = fileView;
    state.fileViewWindowParam = fileViewWindowParam;
  },
  'DELETE_FILEVIEW_WINDOW_PARAM' (state, fileView) {
    let fileViewWindowParam = state.fileViewWindowParam;
    delete fileViewWindowParam[fileView['ROWID']];
    state.fileViewWindowParam = fileViewWindowParam;
  },
  'SET_STORE_FILTER' (state, filter) {
    let datarows = state.dataSet01Source;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.mainGrid = listResult;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
